import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { FormField } from '@adornis/formfield/form-field.js';
import type { Partner } from '@chancenwerk/master-data-management/partner/entities/Partner.js';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { of, switchMap } from 'rxjs';
import { Adresse } from '../../db/adresse.js';
import { PartnerPublicInformationAPI } from '../../public-access/api/PartnerPublicInformationAPI.js';
import './chancen-component-public-school-picker.js';

/**
 * @customElement chancen-component-public-school-id-picker
 *
 * TODO: Replace this with entity id picker
 *
 */
@customElement('chancen-component-public-school-id-picker')
export class ChancenComponentPublicSchoolIdPicker extends FormField<Maybe<string>> {
  @property({ attribute: true, reflect: true, type: String }) public placeholder = 'Partner';
  @property({ attribute: 'only-active', type: Boolean }) public onlyActive: boolean = false;

  @state() private _selectedSchool = new RXController(this, this.value.observable, value$ =>
    value$.pipe(
      switchMap(schoolID =>
        schoolID
          ? PartnerPublicInformationAPI.getByID([schoolID])({
              name: 1,
              kuerzel: 1,
              address: Adresse.allFields,
            }).then(x => x[0])
          : of(null),
      ),
    ),
  );

  override render() {
    return html`
      <x-flex>
        <chancen-component-public-school-picker
          ?disabled=${this.disabled}
          placeholder="Standort"
          emptyState="Keine Standorte gefunden"
          @value-picked=${this.onValuePicked}
          .value=${this._selectedSchool.value}
          error=${ifDefined(this.error)}
          ?only-active=${this.onlyActive}
        ></chancen-component-public-school-picker>
      </x-flex>
    `;
  }

  onValuePicked(e: ValueEvent<Partner>) {
    this.value.next(e.detail.value._id);
    const event = new CustomEvent('value-picked', {
      detail: {
        value: e.detail.value._id,
      },
    });
    this.dispatchEvent(event);
  }
}
